module.exports = __webpack_public_path__ + "img/20_40.f284a9d8.png";